import {Record} from 'immutable';
import {schema} from 'normalizr';
import {ParticipantSchema} from './Participant';
import {WorkflowStatusSchema} from './WorkflowStatus';
import {ThreadTypeSchema} from './ThreadType';
import {ThreadAttributeValueSchema} from './ThreadAttributeValue';
import {ThreadFileSchema} from './ThreadFile';

const Thread = Record({
    id: null,
    subject: null,
    author: null,
    owner: null,
    note: null,
    createdAt: null,
    updatedAt: null,
    files: [],
    attributes: [],
    threadType: null,
    workflowStatus: null,
    createdBy: null,
});

export const ThreadSchema = new schema.Entity('threads', {
    author: ParticipantSchema,
    owner: ParticipantSchema,
    createdBy: ParticipantSchema,
    files: [ThreadFileSchema],
    attributes: [ThreadAttributeValueSchema],
    threadType: ThreadTypeSchema,
    workflowStatus: WorkflowStatusSchema,
});

export default Thread;
